import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import type { MeProfile } from '@/types/profile.types';
import { InfoRow, ManagedByAdminNote, ProfileSectionCard } from './ProfileSectionCard';

const DEPARTMENT_LABEL: Record<NonNullable<MeProfile['department']>['type'], string> = {
  OPERATIONS: 'Operations',
  COMMERCIAL: 'Commercial',
  SERVICE: 'Service',
  GENERAL: 'General',
};

/**
 * Employment — the same section for Owner, Admin, Operations, Commercial,
 * Service Engineer and Master Service Engineer. Department-specific content is
 * DATA (which department, its head), never a separate implementation. Always
 * read-only for the subject (HR / administrator-owned).
 */
export function EmploymentSection({ me }: { me: MeProfile }) {
  const dept = me.department;
  return (
    <ProfileSectionCard title="Employment" icon={faBriefcase} testId="profile-employment">
      <div className="space-y-2">
        <InfoRow label="Employee ID" value={me.employeeCode} />
        <InfoRow label="Designation" value={me.designation} />
        <InfoRow
          label="Department"
          value={dept ? `${dept.name} (${dept.code}) · ${DEPARTMENT_LABEL[dept.type]}` : null}
        />
        <InfoRow label="Department head" value={dept?.headName ?? null} />
        <InfoRow
          label="Reporting manager"
          value={
            me.reportingManager
              ? `${me.reportingManager.name}${me.reportingManager.employeeCode ? ` (${me.reportingManager.employeeCode})` : ''}`
              : null
          }
        />
        <InfoRow label="Roles" value={me.roles.map((r) => r.name).join(', ') || null} />
      </div>
      <ManagedByAdminNote />
    </ProfileSectionCard>
  );
}
